import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../data/store';
import { collection, onSnapshot, query, orderBy } from '@battleops/localstore';

const SectionContext = createContext();

export function SectionProvider({ children }) {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    const q = query(collection(db, 'sections'), orderBy('order', 'asc'));
    const unsub = onSnapshot(q, (snap) => {
      setSections(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    }, () => setSections([]));
    return () => unsub();
  }, []);

  return (
    <SectionContext.Provider value={{ sections }}>
      {children}
    </SectionContext.Provider>
  );
}

export function useSections() {
  const context = useContext(SectionContext);
  if (!context) throw new Error('useSections must be used within SectionProvider');
  return context;
}
